class ProductReviews extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.fetchData()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.listeners.add(this.els.write.element, 'click', this.handleTrigger)
  }

  fetchData () {
    const okendoScripts = document.querySelectorAll(
      '[data-oke-metafield-data]',
    )

    if (okendoScripts.length === 0) return

    this.els.default.element.setAttribute('aria-hidden', 'true')
    this.els.okendo.element.setAttribute('aria-hidden', 'false')

    const reviewScript = [...okendoScripts].find((script) =>
      script.textContent.includes('productAttributes'),
    )

    const data = JSON.parse(reviewScript.textContent)
    const featuredReview = data.reviews.find((review) => review.rating >= 4)

    this.els.review.element.innerText = `"${featuredReview.body}"`
    this.els.author.element.innerText = featuredReview.reviewer.displayName
  }

  handleTrigger () {
    const writeReview = document.querySelector('.oke-w-writeReview')
    writeReview.click()
  }
}

if (!customElements.get('product-reviews')) {
  customElements.define('product-reviews', ProductReviews)
}
